// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"499":"dde5c5a8","714":"f91881f6"}[chunkId] + ".chunk.css";
};